<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="How to Play">
        <template #header>
            How to Play
        </template>
        <div class="sm:flex sm:grid sm:grid-cols-3 items-center justify-center">
            <div class="p-4 sm:h-auto sm:py-5 sm:px-6 sm:shadow sm:rounded transition duration-500 ease-in-out bg-gray-900 col-span-1 col-end-3">
                <h1 class="text-white text-2xl text-center mb-2">How it Works</h1>

                <div class="flex mb-4" v-for="(item, key) in items">
                    <div class="flex shrink mr-4">
                        <span class="border border-racing-stars-yellow rounded-full flex items-center justify-center text-center text-white w-10 h-10">{{ key + 1 }}</span>
                    </div>
                    <div class="text-white">
                        <h2 class="text-2xl font-bold">{{ item.title }}</h2>
                        <span class="" v-html="item.content"></span>
                        <vue-player-video v-if="key == 5" class="z-0 m-4" :src="asset('media/how-it-works.mp4')" colors="#fceb0d" />
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>

import AppLayout from '@/Layouts/Layout'
import VuePlayerVideo from 'vue3-player-video'

export default {
    props: {
        items: {
            type: Array,
            default: []
        }
    },

    setup(props) {

    },

    components: {
        AppLayout,
        VuePlayerVideo,
    }
}

</script>
